// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.active {\n  box-shadow: 0px 2px 10px 3px rgba(120, 120, 120, 0.75);\n  background: #385F73;\n  color: white !important;\n}\n.theme--light.v-data-table .v-data-table-header th .v-data-table-header__icon {\n  color: #fff !important;\n}\n.v-data-table-header .v-data-table__checkbox.v-simple-checkbox .v-input--selection-controls__input .v-icon {\n  color: #fff !important;\n}\n", ""]);
// Exports
module.exports = exports;
